export const SCREEN_HORIZONTAL_SPACING = "21px";
export const SCREEN_VERTICAL_SPACING = "48px";

export const ONE_HOUR_IN_MILLISECONDS = 1000 * 60 * 60;

export const LAST_SELECTED_STATION_KEY = "lastSelectedStation";

export const LAST_SELECTED_ENVIRONMENTAL_TYPE_KEY =
  "lastSelectedEnvironmentalType";
